import { render, staticRenderFns } from "./ManageUsersPage.vue?vue&type=template&id=0248c22a&scoped=true&"
import script from "./ManageUsersPage.vue?vue&type=script&lang=js&"
export * from "./ManageUsersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0248c22a",
  null
  
)

export default component.exports